/* eslint-disable */
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";

import { useNavigate } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { DeleteAchievements, ViewAchievementsDet } from "../../../../api/AuthenticationServices";

const ViewAchievements = (props) => {
  const theme = useTheme();
  const [records, setRecords] = useState([]);
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
    },
  };
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    console.log(config);
    try {
      const res = await ViewAchievementsDet(config);
      if (res.data.status === "success") {
        setRecords(res.data.data);
        console.log("Records ", records);
      }
    } catch (e) {
      console.log("Error " + e);
    }
  }
  const columns = [
    {
      field: "title",
      headerName: "Title",
      cellClassName: "name-column--cell",
    },

    {
      field: "place",
      headerName: "Place",
      flex: 1,
    },

    {
      field: "dateOfAch",
      headerName: "Date",
      flex: 1,
    },
    {
      field: "opponent",
      headerName: "Opponent",
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "edit",
      headerName: "Edit",
      width: 120,
      renderCell: (params) => (
        <Button
          variant="contained"
          startIcon={<EditIcon />}
          onClick={() => handleEdit(params.row)}
        >
          Edit
        </Button>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      width: 120,
      renderCell: (params) => (
        <Button
          variant="contained"
          startIcon={<DeleteIcon />}
          onClick={() => handleDelete(params.row)}
        >
          Delete
        </Button>
      ),
    },
  ];

  const handleDelete = async (row) => {
    // Handle delete button click event here

    try {
      const deleteData = {
        headers: config.headers,
        data: {
          deleteId: row.id,
        },
      };
      console.log("DAta : ", deleteData);
      const delRes = await DeleteAchievements(deleteData);
      if (delRes.data.status === "success") {
        alert(delRes.data.message);
      } else {
        alert(delRes.data.message);
      }
    } catch (error) {
      alert(error.message);
    }
    navigate("/admin/viewachievements");
  };
  const handleEdit = (row) => {
    // Handle edit button click event here

    navigate(`/admin/editachievements/`, { state: { acrow: row } });
  };
  return (
    <Box m="20px">
      <Header title="ACHIEVEMENTS" subtitle="List of achievement details" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={records}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />
      </Box>
    </Box>
  );
};

export default ViewAchievements;
